import React from 'react';
import DownloadLink from '../helper/DowloadLink';
import tubulins from '../images/tubulins.gif';
import MultipleDatasets from '../datasetsPage/MultipleDatasets';

class ChallengeSimulatedData extends React.Component {
    constructor(props){
        super(props)
        this.state = {'update':false}
        this.MTxList=[]; this.ERList=[]; this.MT0List=[]; this.Tub2D=[]
        this.Tub2DTrain=[]; this.Eye=[]; this.Snow=[]; this.Seashell =[]
        this.beads =[];
        this.fetchData = this.fetchData.bind(this)
    }
    componentDidMount(){
        this.fetchData('challenge2016')
        this.fetchData('challenge2013')
    }
    // fetch the list of jsons from server
    fetchData(name){
        const data = new FormData();
        data.append('name',name);
        fetch('/api/getDatasets',
        {
            method: 'post',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
            body: data
        }).then (response => {
            if (response.ok) {
                response.json().then(dataList => {
                    // group according to name => display using MultipleDataset component
                    if (name === 'challenge2016') {
                        this.MTxList = dataList.filter((d) => {return (d['name'].indexOf('MT1') >= 0 || d['name'].indexOf('MT2') >= 0 ||
                                                                        d['name'].indexOf('MT3') >= 0 || d['name'].indexOf('MT4') >= 0)})
                        this.ERList = dataList.filter((d) => {return (d['name'].indexOf('ER') >= 0)})
                        this.MT0List = dataList.filter((d) => {return (d['name'].indexOf('MT0') >= 0)})
                        this.beads = dataList.filter((d) => {return (d['name'].indexOf('beads') >= 0)})
                    }
                    else {
                        //this.Tub2D = dataList.filter((d) => {return (d['name'].indexOf('Tub2D') >= 0)})
                        this.Tub2DTrain = dataList.filter((d) => {return (d['name'].indexOf('Tubulins') >= 0)})
                        this.Eye = dataList.filter((d) => {return (d['name'].indexOf('Eye') >= 0)})
                        this.Snow = dataList.filter((d) => {return (d['name'].indexOf('Snow') >= 0)})
                        this.Seashell = dataList.filter((d) => {return (d['name'].indexOf('Seashell') >= 0)})
                    }
                    if (this.MTxList.length > 0 & this.Tub2DTrain.length > 0)
                        this.setState({update:!this.state.update})

                })
            }
        })
    }
    
    render() {
        return (
        <div>
            <div>
                    <h1>Simulated datasets</h1>
                    <p className="abstract">
                    The benchmarking of SMLM software package mainly relies on the usage of common reference datasets.
                    </p>
                    <img src={tubulins}  alt="banner" style={{"float":"right","paddingLeft":"10px", "width":"300px"}}/>
                    <div className="abstract">
                        This page contains a collection of 2D and 3D localization microscopy simulated datasets.<br></br>
                        The experimental imaging condition of each simulated dataset is encoded in their name:
                        <ul className="list-bullet" style={{"marginLeft":"20px"}}>
                            <li><b>N1:</b> Typical photon counts and background levels for Alexa647 labelled STORM sample.</li>
                            <li><b>N2:</b> Photoswitchable fluorescent protein labelled sample such as mEos2 or Dendra2.</li>
                            <li><b>N3:</b> Typical photon counts and level of background for site specific dye-labelled live cell STORM sample such as ER Tracker.</li>
                            <li><b>LD:</b> Low density</li>
                            <li><b>HD:</b> High density</li>
                        </ul>
                    </div>
                    <p style={{"padding":"20px","clear":"both"}}></p>          
               
            </div>
            <div>
                <h3>Realistic Simulations - 3D - Experimental PSF</h3>
                <p style={{"textAlign":"justify"}}>
                The experimental datasets consist of sequences of frames from real stained biologicial samples. 
                A Z-stack of beads is provided for the axial calibration. The same 3D simulated structure is imaged in different experimental conditions
                and for different modality: 2D, 3D astigmatism (AS), 3D biplane (BP), and 3D double-helix (DH). 
                As a testing phase, we have also the quad-plane (QP) datasets for high-density conditions. The training datasets are provided with ground-truth localizations.
                </p>
                <p>Published June 7, 2016 as training dataset for the SMLM challenge 2016</p>
                {<MultipleDatasets data={this.MTxList} title={"Microtubules - Contest datasets"} 
                rootDir={"./../datasets/challenge2016"} history={this.props.history}/>}
                {<MultipleDatasets data={this.ERList} title={"Endoplasmic Reticulum - Contest datasets"} 
                rootDir={"./../datasets/challenge2016"} history={this.props.history}/>}
                {<MultipleDatasets data={this.MT0List} title={"Microtubules - Training datasets (Ground-truth localizations publicly availables)"} 
                rootDir={"./../datasets/challenge2016"} history={this.props.history}/>}
            </div>
            <hr></hr>
            <div>
                <h3>Beads calibration - 3D</h3>
                <p style={{"textAlign":"justify"}}></p>
                <p>Published June 7, 2016.</p>
                {<MultipleDatasets data={this.beads} title={"Calibration - Z-stack of beads"} 
                rootDir={"./../datasets/challenge2016"} history={this.props.history}/>}
            </div>
            <hr></hr>
            <div>
                <h3>Realistic Simulations - 2D - Theoretical PSF</h3>
                <p style={{"textAlign":"justify"}}>
                These datasets are simulated sequence of realistic frames. 
                The bio-inspired samples are 3D continuous models that imitates biological 
                structures. These datasets were used for the challenge 2013. </p>
                <p>Published February 1, 2013 as training dataset for the SMLM challenge 2013</p>
                {/*<MultipleDatasets data={this.Tub2D} title={"Tubular structure • Constest datasets"} 
                rootDir={"./../datasets/challenge2013"} history={this.props.history}/>*/}
                {<MultipleDatasets data={this.Tub2DTrain} title={"Tubular structure • Training datasets"} 
                rootDir={"./../datasets/challenge2013"} history={this.props.history}/>}
            </div>
            <hr></hr>
            <div>
                <h3>Artificial Constructions</h3>
                <p style={{"textAlign":"justify"}}>
                These datasets represents artificial structure with some actived fluorophores 
                at some specific postions. These datasets are mainly used to evaluated 
                particular features of the localization software, like the ability to 
                discriminate two neighboring fluorophores in the same frame.  </p>
                {<MultipleDatasets data={this.Eye} title={"Eye"} 
                rootDir={"./../datasets/challenge2013"} history={this.props.history}/>}
                {<MultipleDatasets data={this.Snow} title={"Snow"} 
                rootDir={"./../datasets/challenge2013"} history={this.props.history}/>}
                {<MultipleDatasets data={this.Seashell} title={"Seashell"} 
                rootDir={"./../datasets/challenge2013"} history={this.props.history}/>}
            </div>
            <hr></hr>
        </div>
      );
    }
}

export default ChallengeSimulatedData;